import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TrackerCompanies = _resolveComponent("TrackerCompanies")
  const _component_TrackerContacts = _resolveComponent("TrackerContacts")
  const _component_TrackerTopics = _resolveComponent("TrackerTopics")

  return ($props.widget.type === 'tracker_companies')
    ? (_openBlock(), _createBlock(_component_TrackerCompanies, {
        key: 0,
        widget: $props.widget
      }, null, 8 /* PROPS */, ["widget"]))
    : ($props.widget.type === 'tracker_contacts')
      ? (_openBlock(), _createBlock(_component_TrackerContacts, {
          key: 1,
          widget: $props.widget
        }, null, 8 /* PROPS */, ["widget"]))
      : ($props.widget.type === 'tracker_topics')
        ? (_openBlock(), _createBlock(_component_TrackerTopics, {
            key: 2,
            widget: $props.widget
          }, null, 8 /* PROPS */, ["widget"]))
        : _createCommentVNode("v-if", true)
}